export default __webpack_public_path__ + "6670f6cc85998c55c4280be49c80604c.png";